import { ReactNode, createContext, useState } from 'react'


const VehicleEnquiryContext = createContext({});

export const VehicleEnquiryProvider = ({ children }: { children: ReactNode }) => {
    const [open, setOpen] = useState<boolean>(false);
    const [vehicleClassId, setVehicleClassId] = useState<number>(0);

    const value = { open, setOpen, vehicleClassId, setVehicleClassId };

    return (
        <VehicleEnquiryContext.Provider value={value}>
            {children}
        </VehicleEnquiryContext.Provider>
    )
}

export default VehicleEnquiryContext
